import dayjs from "dayjs";
import firebase from "firebase";

export const getJobStructure = ({form, store, index, job, obj, user, reporter}) => {
  console.log(job, "JOB")


  delete job.job.reports
  delete job.job.job
  const result = {
    workOrderIndex: form.index,
    "notifications": [],
    "approve": false,
    "reportTECH": null,
    "reportPROF": null,
    "TECH": {
      "workers": 0,
      "itr": 0,
      "workers_plan": 0,
      "itr_plan": 0,
      "index": null,
      ...job.TECH
    },
    "PROF": {
      "workers": 0,
      "itr": 0,
      "workers_plan": 0,
      "itr_plan": 0,
      "index": null,
      ...job.PROF
    },
    "jobs_internal": [],
    "work_type": [],
    "work_type_dir": [],
    "daily_plan": {
      "workers": "",
      "itr": ""
    },
    "joints": [
      {
        "id_joint": null,
        "welder": null,
        "materials": null,
        "leader": null,
        "axe_elevation": null
      }
    ],
    "leader": null,
    "place": null,
    "line": {},

    datetime: dayjs(job.datetime).format(),
    dateunix: dayjs(dayjs(job.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
    "comment": job.comment,
    "object": {
      "name": obj.name,
      "id": (job.objects && job.objects[0]) || (job.job && job.job.objects && job.job.objects[0]) || null
    },
    "group": [],
    name: job.job.name || job.name,
    "jobs": [
      {
        job: {
          ...job.job,
          name: job.job.name || job.name,
          isCreate: true,
          value: job.value || 0,
          "comment": job.job.comment,
          unit: (job.job.unit && (job.job.unit.label ? job.job.unit.label : job.job.unit)) || (job.unit && (job.unit.label ? job.unit.label : job.unit)) || null,
          unit_id: job.job.unit_id  || job.unit_id ||
            (job.job.unit && (job.job.unit.value ? job.job.unit.value : null)) || (job.unit && (job.unit.value ? job.unit.value : null)) || null,
        },
        value: job.value || 0,
        uid: job.uid,
        "comment": job.job.comment,
      }
    ],
    "files": job.files || [],
    "turn": job.turn || {
      label: 1,
      value: 1,
    },
    "joints_ids": [],
    "form": null,
    "jobs_ids": [
      job.originalId
    ],
    planId: (store.state.project.plan && store.state.project.plan.id) || null,
    "work_type_ids": [
      null
    ],
    "extended_data": {},
    "emailOwnerProject": firebase.auth().currentUser.email,
    "company": "",
    "reporterId": firebase.auth().currentUser.uid,
    "type": "JOB",
    isWorkOrder: true,
    "user": reporter || job.user || user,
    category: form.category,
    executor: user,
    status: form.status,
    "reporter": reporter
  }

  if (index) {
    result.index = index
  }

  return result
}



export const getJobStructurePROF = ({form, store, index, job, obj, user, reporter}, jobs) => {

  delete job.job.reports

  const result = {
    workOrderIndex: form.index,
    "notifications": [],
    "approve": false,
    "reportTECH": null,
    "reportPROF": null,
    "TECH": {
      "workers": 0,
      "itr": 0,
      "workers_plan": 0,
      "itr_plan": 0,
      "index": null,
      ...job.TECH
    },
    "PROF": {
      "workers": 0,
      "itr": 0,
      "workers_plan": 0,
      "itr_plan": 0,
      "index": null,
      ...job.PROF
    },
    "jobs_internal": [],
    "work_type": [],
    "work_type_dir": [],
    "daily_plan": {
      "workers": "",
      "itr": ""
    },
    "joints": [
      {
        "id_joint": null,
        "welder": null,
        "materials": null,
        "leader": null,
        "axe_elevation": null
      }
    ],
    "leader": null,
    "place": null,
    "line": {},

    datetime: dayjs(job.datetime).format(),
    dateunix: dayjs(dayjs(job.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
    "comment": job.comment,
    "object": {
      "name": obj.name,
      "id": (job.objects && job.objects[0]) || (job.job && job.job.objects && job.job.objects[0]) || null
    },
    "group": [],
    name: job.job.name || job.name,
    "jobs": {
      0: [
        ...jobs.map((d) => {
          const originalJob = JSON.parse(JSON.stringify(d.originalJob))

          const result = JSON.parse(JSON.stringify({
            ...d,
            job: originalJob.job || originalJob
          }))



          delete result.originalJob
          delete result.job.originalJob


          return result
        })
      ]
    },
    "files": job.files || [],
    "turn": job.turn || {
      label: 1,
      value: 1,
    },
    "joints_ids": [],
    "form": null,
    "jobs_ids": [
      job.originalId
    ],
    planId: (store.state.project.plan && store.state.project.plan.id) || null,
    "work_type_ids": [
      null
    ],
    "extended_data": {},
    "emailOwnerProject": firebase.auth().currentUser.email,
    "company": "",
    "reporterId": firebase.auth().currentUser.uid,
    "type": "PROF",
    isWorkOrder: true,
    "user": reporter || job.user || user,
    category: form.category,
    executor: user,
    status: form.status,
    "reporter": reporter,
  }

  if (index) {
    result.index = index
  }

  return result
}



// WEBPACK FOOTER //
// ./src/utils/jobStructure.js